module.exports = __webpack_public_path__ + "img/coronavirus.495ef6a2.jpg";